<template>
  <div id="index">
  </div>
</template>

<script>
export default {
  name: 'Index',

  /*
   * created: 初期処理
   */
  created : function(){
console.log('index - created');
  },
}
</script>
<style>
</style>
